import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  constructor() {}

  editSection = new EventEmitter<unknown>();
  duplicate = new EventEmitter<unknown>();
  delete = new EventEmitter<unknown>();

  //reference services

  backgroundImageChangeCheck = new EventEmitter<unknown>();
  colorOverlayChangeChecks = new EventEmitter<unknown>();
  alignmentChangeChecks = new EventEmitter<unknown>();
  animationChangeChecks = new EventEmitter<unknown>();
  spacingChangeChecks = new EventEmitter<unknown>();
  borderChangeChecks = new EventEmitter<unknown>();
  cardSizeChangeChecks = new EventEmitter<unknown>();
  imageStyleChangeChecks = new EventEmitter<unknown>();
  cornerChangeChecks = new EventEmitter<unknown>();
  textBackgroundChangeChecks = new EventEmitter<unknown>();
  buttonStyleChangeChecks = new EventEmitter<unknown>();
  postionLayoutChangeChecks = new EventEmitter<unknown>();
  contentAlignmentChangeCheck = new EventEmitter<unknown>();
}
